import { ArrowDownRight, ArrowUpRight, Minus } from "lucide-react";
import { eur, pctChange } from "./format";

export const MetricCard = ({ id, label, hint, value, count, countNoun, countLabel, previousValue, invertDelta = false, accent, icon: Icon, footnote, action, tag }) => {
  const delta = previousValue === undefined ? undefined : pctChange(value, previousValue);
  const good = delta === null || delta === 0 ? null : (delta > 0) !== invertDelta;
  const DeltaIcon = delta === null || delta === 0 ? Minus : delta > 0 ? ArrowUpRight : ArrowDownRight;
  const deltaCls = good === null ? "text-slate-400" : good ? "text-emerald-400" : "text-rose-400";

  return (
    <div
      data-testid={`sales-metric-${id}`}
      className="relative overflow-hidden rounded-2xl bg-slate-900/70 p-6 ring-1 ring-white/5 backdrop-blur transition-transform duration-200 hover:-translate-y-0.5"
    >
      <span className="absolute left-0 top-0 h-full w-1.5" style={{ backgroundColor: accent }} />
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="flex flex-wrap items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-slate-400">
            {label}
            {tag && <span className="rounded-full bg-amber-500/15 px-2 py-0.5 text-[10px] font-bold tracking-normal text-amber-300 ring-1 ring-amber-500/30" data-testid={`sales-metric-${id}-tag`}>{tag}</span>}
          </p>
          {hint && <p className="mt-0.5 text-xs text-slate-500">{hint}</p>}
        </div>
        <span className="flex items-center gap-1.5">
          {action}
          <span className="flex h-10 w-10 items-center justify-center rounded-lg ring-1 ring-white/10" style={{ backgroundColor: `${accent}1a`, color: accent }}>
            <Icon className="h-5 w-5" />
          </span>
        </span>
      </div>
      <p className={`font-mono mt-5 text-4xl font-bold tracking-tight sm:text-5xl ${value < 0 ? "text-rose-300" : "text-slate-50"}`} data-testid={`sales-metric-${id}-value`}>
        {eur(value)}
      </p>
      <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm">
        <span className="text-slate-300" data-testid={`sales-metric-${id}-count`}>
          {countLabel !== undefined ? countLabel : <><span className="font-mono font-semibold">{count}</span> {countNoun}{count === 1 ? "" : "s"}</>}
        </span>
        {delta !== undefined && (
        <span className={`inline-flex items-center gap-1 font-semibold ${deltaCls}`} data-testid={`sales-metric-${id}-delta`}>
          <DeltaIcon className="h-4 w-4" />
          {delta === null ? "no prior month" : `${Math.abs(delta)}% vs last month`}
        </span>
        )}
      </div>
      {footnote && <p className="mt-3 text-[11px] leading-relaxed text-slate-400">{footnote}</p>}
    </div>
  );
};
